/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/home'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Administration</span>
        </div>
      </div>
    
      <AsideMenuItemWithSub
        to='#'
        title='People'
        icon='/media/icons/duotune/communication/com014.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/viewcustomers' title='Customers' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Users' hasBullet={true} />
        <AsideMenuItem to='/viewsuppliers' title='Suppliers' hasBullet={true} />
      </AsideMenuItemWithSub>
     

      <AsideMenuItemWithSub
        to='#'
        title='Stock'
        icon='/media/icons/duotune/ecommerce/ecm006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/viewproducts' title='Products' hasBullet={true} />
        <AsideMenuItem to='/viewpurchases' title='Purchases' hasBullet={true} />

        <AsideMenuItem to='/norights' title='Purchase Orders' hasBullet={true} />
        
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='#'
        title='Cash Flow'
        icon='/media/icons/duotune/ecommerce/ecm008.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/expenses' title='Expenses' hasBullet={true} />
        <AsideMenuItem to='/sales' title='Sales' hasBullet={true} />
        <AsideMenuItem to='/profitorloss' title='Profit or Loss' hasBullet={true} />
        <AsideMenuItemWithSub to='#' title='Transactions' hasBullet={true}>
          <AsideMenuItem to='/transactionsmpesa' title='Mpesa' hasBullet={true} colorTitle={"text-success"}/>
          
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>

     
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Reports</span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='#'
        title='General Reports'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/graphs/gra001.svg'
      >
        <AsideMenuItem to='/norights' title='Sales Report' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Expense Report' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Product Report' hasBullet={true} />
      </AsideMenuItemWithSub>
      
     
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Tools</span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='#'
        title='POS Settings'
        icon='/media/icons/duotune/coding/cod001.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/norights' title='User Roles' hasBullet={true} />
        <AsideMenuItem to='/norights' title='User Designation' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Product Units' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Expense Types' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Payment Types' hasBullet={true} />
        <AsideMenuItem to='/norights' title='Product Categories' hasBullet={true} />
      </AsideMenuItemWithSub>
  
  
     
    </>
  )
}
